import React from 'react'
import './Header.css'
import Button from 'react-bootstrap/Button';
import Container from 'react-bootstrap/Container';
import Form from 'react-bootstrap/Form';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import logo from './../../assets/images/logo1.png'
import Cookies from "universal-cookie";
import { useDispatch } from 'react-redux';
import { resetUser } from '../../redux/CustomerReducer';
import { Link } from 'react-router-dom';


const cookies = new Cookies();

const Header = () => {

  const token=cookies.get("token");
  const userType=cookies.get("userType");
const dispatch=useDispatch();
  console.log("cookiesToken",token,userType)


  const logoutClicked=()=>{
dispatch(resetUser())
    cookies.remove('token', { path: '/' })
    cookies.remove('_id', { path: '/' })
    // window.location.reload(true)

    window.location.assign("/");

  }
  
  return (
    <>
     <Navbar bg="light" expand="lg" className='header'>
      <Container fluid>
        <Navbar.Brand className='navbarBrand' href="#">
            
        <img src={logo} className="logoMainHeader"/>
            
            </Navbar.Brand>
        <Navbar.Toggle aria-controls="navbarScroll" />
        <Navbar.Collapse id="navbarScroll">
          <Nav
            className="me-auto my-2 my-lg-0 logoNavMobile"
            style={{ maxHeight: '100px' }}
            navbarScroll
          >
            <Nav.Link href="/">
            <Link to="/">
                <img src={logo} className="logoMainHeader logoMainHeaderHide"/>
                </Link>
                
                </Nav.Link>
      
          </Nav>
          <Nav
            className="me-auto my-2 my-lg-0 topNavLinkHeader"
            style={{ maxHeight: '100px' }}
            navbarScroll
    
          >
            <Nav.Link >
              <Link to="/">
              Home
              </Link>
              
              </Nav.Link>
            <Nav.Link href="">
              <Link to="/customer/ourServices"> 
              
              Our Services
              </Link>
              
              </Nav.Link>
            <Nav.Link href="">
            <Link to="/customer/ourFleets">
            
            
            Our Fleets
            </Link>  
              </Nav.Link>
            {/* <Nav.Link href="">
              <Link to="/customer/driveWithUs">
              Drive With Us
              
              </Link>
              </Nav.Link> */}
            <Nav.Link href="">
              <Link to="/customer/contactUs">
              Contact Us
              </Link>
              </Nav.Link>
            {/* <Nav.Link href="#action1">About Us</Nav.Link> */}
            {(token && userType) &&<Nav.Link >
            <Link to="/customer/profile">
              
              Profile
              </Link>
              
              </Nav.Link>}
           {token&& <Nav.Link href="#action1">
           <Link to="/customer/myBookings">
            My Bookings
            
            </Link>
            </Nav.Link>}
            
        { (token && userType) &&
        <Nav.Link href="#"
        onClick={logoutClicked}
        >Logout</Nav.Link>}
       {!(token && userType) && <Nav.Link href="/customer/login">Login</Nav.Link>}
           
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
    
    </>
  )
}

export default Header